import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { INVOICE_TYPE_CODE } from "Components/Constants/InvoiceTypeCode";
import { KOT_STATUS } from "Components/Constants/KotStatus";
import { KOT_TYPE } from "Components/Constants/KotType";
import DeliveryTruck from "Components/icons/DeliveryTruck";
import Dine from "Components/icons/Dine";
import { StreamLine } from "Components/icons/StreamLine";
import TakeAway from "Components/icons/TakeAway";
import { handleError } from "Helper/handleError";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import KotServiceService from "Service/Kot/KotService.service";
import PrintBill from "./Receipt/DineTemplate/kot_Template";
import { pageStyle } from "Components/Print/printPagesStyles";
import { ITEM_DEPARTMENT_CODES } from "Components/Constants/ItemDepartment";

const KotCardView = ({
  kot,
  kotColor,
  handleProcessKot = null,
  handleComplete = null,
  showProcessingButton,
  showCompleteButton,
  fetchKot = null,
  preventPrint,
  icon,
  departmentCode,
  // disablePrintCount
}) => {
  // console.log(kot);

  const BONE_WHITE_COLOR = "rgba(255, 253, 241, 0.95)";
  const FONT_COLOR = "#7a7a7a";
  const SECONDARY_FONT_COLOR = "#838383";

  const ICON_HEIGHT = "2em";
  const ICON_WIDTH = "2em";

  const dispatch = useDispatch();

  const [kotData, setKotData] = useState();
  const [rawKot, setRawKot] = useState(null)
  const [selectedKotCode, setSelectedKotCode] = useState(null);

  const kotPrintRef = useRef(null);

  const getKotDetail = async (code) => {
    // console.log(code);
    // return
    try {
      let printData;
      const res = await KotServiceService.getPrevKot(code);
      setRawKot(res)

      if (departmentCode) {
        if (departmentCode == ITEM_DEPARTMENT_CODES.MAIN_KITCHEN) {
          printData = res?.stockHistoryTemps?.filter((stockHistory) => {
            return (
              stockHistory.itemMaster.departmentCode ==
              ITEM_DEPARTMENT_CODES.MAIN_KITCHEN
            );
          });
        } else if (departmentCode == ITEM_DEPARTMENT_CODES.BEVERAGES) {
          printData = res?.stockHistoryTemps?.filter((stockHistory) => {
            return (
              stockHistory.itemMaster.departmentCode ==
              ITEM_DEPARTMENT_CODES.BEVERAGES
            );
          });
        }
      } else {
        printData = res;
      }

      setKotData(printData);
    } catch (e) {
      dispatch(openSnackbar(true, "error", handleError(e)));
    }
  };

  const updateKotCount = async (code) => {
    try {
      const res = await KotServiceService.updateKotPrintCount(code);
      // console.log(res);
      if (res?.status == 200) {
        setSelectedKotCode(null);
        fetchKot();
      }
    } catch (e) {
      dispatch(openSnackbar(true, "error", handleError(e)));
    }
  };

  const handlePrintKot = useReactToPrint({
    content: () => kotPrintRef.current,
    onAfterPrint: () => {
      setKotData();
      updateKotCount(selectedKotCode);
      // fetchKot?.();
    },
    pageStyle: pageStyle.receipt,
  });

  useEffect(() => {
    if (kotData) {
      handlePrintKot();
    }
  }, [kotData]);

  // console.log(kot);

  return (
    <>
      <Box
        sx={{
          breakInside: "avoid",
          mb: 2.5,
          p: 2.5,
          borderRadius: 4,
          position: "relative",
          background: `linear-gradient(135deg, ${kotColor} 0%, rgba(0,0,0,0.25) 100%)`,
          boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
          transition: "all 0.25s ease",
          ...((kot.invoiceStatus === KOT_STATUS.KOT_PARTIALLY_PROCESSING ||
            kot.invoiceStatus === KOT_STATUS.KOT_PARTIALLY_COMPLETED) && {
            animation: "beat 1s infinite",
          }),

          "@keyframes beat": {
            "0%": {
              transform: "scale(1)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
            },
            "50%": {
              transform: "scale(1.04)",
              boxShadow: `0 15px 35px ${kotColor}`,
            },
            "100%": {
              transform: "scale(1)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
            },
          },

          "&:hover": {
            transform: "translateY(-2px)",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: BONE_WHITE_COLOR,
            pt: 3,
            pb: 8,
            px: 1,
            borderRadius: 3,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: 16,
              fontWeight: 800,
              mb: 1,
              color: kotColor,
              letterSpacing: 0.5,
            }}
          >
            KOT Code: #{kot.code}
          </Typography>

          {kot.kotType == KOT_TYPE.DINE ? (
            <>
              {/* Customer name */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  px: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: kotColor,
                      letterSpacing: 0.5,
                    }}
                  >
                    {kot.invoiceType == INVOICE_TYPE_CODE.DELIVERY ? (
                      <DeliveryTruck width={ICON_WIDTH} height={ICON_HEIGHT} />
                    ) : kot.invoiceType == INVOICE_TYPE_CODE.TAKE_AWAY ? (
                      <TakeAway width={ICON_WIDTH} height={ICON_HEIGHT} />
                    ) : (
                      <Dine width={ICON_WIDTH} height={ICON_HEIGHT} />
                    )}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: kotColor,
                      letterSpacing: 0.5,
                    }}
                  >{` - ${kot.customer?.firstName}`}</Typography>
                </Box>
              </Box>

              {/* Print count & Desk */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent:
                    kot?.kotPrintCount > 0 ? "space-between" : "center",
                  alignItems: "center",
                  px: 2,
                }}
              >
                {/* Print count - PC */}
                {kot?.kotPrintCount > 0 && (
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: kotColor,
                    }}
                  >
                    PC:{" "}
                    {kot.kotPrintCount < 10
                      ? "0" + kot.kotPrintCount
                      : kot.kotPrintCount}
                  </Typography>
                )}

                {/* Desk */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: kotColor,
                      letterSpacing: 0.5,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {kot?.desk?.deskName}
                    {kot?.subKotCounts > 0 ? (
                      <Typography
                        sx={{
                          fontWeight: 700,
                          bgcolor: kotColor,
                          letterSpacing: 0.5,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: 24,
                          height: 24,
                          px: 1,
                          borderRadius: "999px",
                          color: "#fff",
                          fontSize: 12,
                        }}
                      >
                        {kot.subKotCounts}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>
              </Box>
            </>
          ) : (
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                color: kotColor,
                letterSpacing: 0.5,
                justifyContent:
                  kot.kotPrintCount > 0 ? "space-between" : "center",
                px: 2,
                mt: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: kotColor,
                    letterSpacing: 0.5,
                  }}
                >
                  {kot.invoiceType == INVOICE_TYPE_CODE.DELIVERY ? (
                    <DeliveryTruck width={ICON_WIDTH} height={ICON_HEIGHT} />
                  ) : kot.invoiceType == INVOICE_TYPE_CODE.TAKE_AWAY ? (
                    <TakeAway width={ICON_WIDTH} height={ICON_HEIGHT} />
                  ) : (
                    <Dine width={ICON_WIDTH} height={ICON_HEIGHT} />
                  )}
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 700,
                    color: kotColor,
                    letterSpacing: 0.5,
                  }}
                >{` - ${kot.customer?.firstName}`}</Typography>
              </Box>

              {kot?.kotPrintCount > 0 && (
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: kotColor,
                  }}
                >
                  PC:{" "}
                  {kot.kotPrintCount < 10
                    ? "0" + kot.kotPrintCount
                    : kot.kotPrintCount}
                </Typography>
              )}
            </Typography>
          )}

          {/* KOT Items */}
          {kot.stockHistoryTemps.map((row, index) => {
            // console.log(row);
            return (
              <List
                key={index}
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  py: 0,
                  color: "#000",
                }}
              >
                <ListItem
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      background: "linear-gradient(135deg, #d6d6d6, #f0f0f0)",
                      p: 1,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {icon ? icon : <StreamLine />}
                  </Box>

                  <ListItemText
                    sx={{ ml: 1 }}
                    primary={
                      <Typography sx={{ fontWeight: 600, color: FONT_COLOR }}>
                        {row?.itemMaster?.name}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="caption"
                        sx={{
                          color: SECONDARY_FONT_COLOR,
                        }}
                      >
                        Rs. {row?.itemMaster?.retailPrice}
                      </Typography>
                    }
                  />

                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 600,
                      color: FONT_COLOR,
                    }}
                  >
                    {row?.quantity}
                  </Typography>
                </ListItem>
              </List>
            );
          })}
        </Box>

        {/* KOT No. Circle */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: -7,
          }}
        >
          <Box
            sx={{
              width: 110,
              height: 110,
              p: 1,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${kotColor}, #000)`,
              boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
            }}
          >
            {preventPrint ? (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 700, color: "#fff" }}
                >
                  #{kot.kotCounts}
                </Typography>
                <Typography sx={{ fontSize: 10, opacity: 0.8, color: "#fff" }}>
                  KOT No.
                </Typography>
              </Box>
            ) : (
              <Button
                type="button"
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
                onDoubleClick={async () => {
                  setSelectedKotCode(kot.code);
                  await getKotDetail(kot.code);
                  // setConfirmPrint(true);
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 700, color: "#fff" }}
                >
                  #{kot.kotCounts}
                </Typography>
                <Typography sx={{ fontSize: 10, opacity: 0.8, color: "#fff" }}>
                  KOT No.
                </Typography>
              </Button>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            mt: 5,
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {showProcessingButton && (
            <Button
              sx={{
                px: 3,
                py: 1,
                minWidth: 120,
                borderRadius: 8,
                fontWeight: 700,
                textTransform: "none",
                letterSpacing: 0.5,
                transition: "all 0.3s ease",
                background: BONE_WHITE_COLOR,
                color: kotColor,
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",

                "&:hover": {
                  background: kotColor,
                  color: "#fff",
                  transform: "translateY(-2px)",
                },

                "&:active": {
                  transform: "translateY(0px)",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                },

                "&.Mui-disabled": {
                  background: "linear-gradient(135deg, #999, #666)",
                  color: "#eee",
                  boxShadow: "none",
                },
              }}
              onClick={() => {
                handleProcessKot(kot);
              }}
              disabled={
                kot.invoiceStatus === KOT_STATUS.KOT_COMPLETE ||
                kot.invoiceStatus === KOT_STATUS.KOT_COMPLETE_WITH_INVOICE
              }
            >
              Processing
            </Button>
          )}
          {showCompleteButton && (
            <Button
              sx={{
                px: 3,
                py: 1,
                minWidth: 120,
                borderRadius: 8,
                fontWeight: 700,
                textTransform: "none",
                letterSpacing: 0.5,
                transition: "all 0.3s ease",
                background: `linear-gradient(135deg, ${kotColor}, #000)`,
                color: "#fff",
                boxShadow: "0 6px 15px rgba(0,0,0,0.3)",

                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.4)",
                },
              }}
              onClick={() => handleComplete(kot)}
              disabled={
                kot.invoiceStatus === KOT_STATUS.KOT_COMPLETE ||
                kot.invoiceStatus === KOT_STATUS.KOT_COMPLETE_WITH_INVOICE
              }
            >
              Complete
            </Button>
          )}
        </Box>
      </Box>

      <div hidden>
        {kotData && (
          <PrintBill
            ref={kotPrintRef}
            divideByConditionally
            submittedData={rawKot}
            dividedKotData={kotData}
            
          />
        )}
      </div>
    </>
  );
};

export default KotCardView;
